import type { Character, MoveRef } from '@/schemas/character';

/**
 * **FI-45 C2 (2026-05-22)** — SSOT lookup di un `MoveRef` posseduto dal
 * PG (`Character.moves`) per ID. Sostituisce 5 callsite ad-hoc che
 * facevano `character.moves.find((m) => m.id === moveId)` o
 * `character.moves.some((m) => m.id === moveId)`.
 *
 * **Distinzione semantica da `findMoveByIdGlobal`**:
 *  - `findMoveByIdGlobal` cerca nel **catalogo globale** delle mosse del
 *    gioco (12 classi + comuni).
 *  - `findMoveRefInCharacter` cerca tra le mosse **possedute dal PG**
 *    (con setup compilato runtime).
 *
 * I nomi sono distinti di proposito per evitare confusione tra "esiste
 * nel gioco" e "il PG ce l'ha".
 *
 * Accetta `Pick<Character, 'moves'>` per essere utilizzabile anche dai
 * caller con tipo ristretto (es. `archetypeGrants.ts` che passa solo i
 * 3 campi necessari del Character).
 */
export function findMoveRefInCharacter(
  character: Pick<Character, 'moves'>,
  moveId: string,
): MoveRef | undefined {
  return character.moves.find((m) => m.id === moveId);
}

/**
 * **FI-45 C2** — variante boolean. Coerente con la convenzione
 * `findX/hasX` (`findSpellsByClass` ↔ `hasMoveSetup`, ecc.).
 */
export function hasMoveRefInCharacter(
  character: Pick<Character, 'moves'>,
  moveId: string,
): boolean {
  return character.moves.some((m) => m.id === moveId);
}
